import React from 'react'

export const About = () => {
    return (
        <div>
            <p>I am in about screen.</p>
            Hello
        </div>
    )
}